import { render } from "./PrivacyPolicy.vue?vue&type=template&id=10d9cacd&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=10d9cacd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d9cacd"]])

export default __exports__